import { INCORPORATION_FORM_SOURCE } from "constants/incorporation";
import {
  useCreateFormInstanceNodeMutation,
  useCreateFormTemplateNodeMutation,
  useDeleteFormInstanceNodeMutation,
  useDeleteFormTemplateNodeMutation,
  useReorderFormInstanceTreeMutation,
  useReorderFormTemplateTreeMutation,
  useUpdateFormInstanceNodeMutation,
  useUpdateFormTemplateNodeMutation,
} from "store/apis/incorporationFormBuilder";

type UseFormTreeNodeMutationsArgs = {
  source: "instance" | "template";
};

export const useCreateFormTreeNodeMutation = ({
  source,
}: UseFormTreeNodeMutationsArgs) => {
  const templateResult = useCreateFormTemplateNodeMutation();
  const instanceResult = useCreateFormInstanceNodeMutation();

  return source === INCORPORATION_FORM_SOURCE.TEMPLATE
    ? templateResult
    : instanceResult;
};

export const useUpdateFormTreeNodeMutation = ({
  source,
}: UseFormTreeNodeMutationsArgs) => {
  const templateResult = useUpdateFormTemplateNodeMutation();
  const instanceResult = useUpdateFormInstanceNodeMutation();

  return source === INCORPORATION_FORM_SOURCE.TEMPLATE
    ? templateResult
    : instanceResult;
};

export const useDeleteFormTreeNodeMutation = ({
  source,
}: UseFormTreeNodeMutationsArgs) => {
  const templateResult = useDeleteFormTemplateNodeMutation();
  const instanceResult = useDeleteFormInstanceNodeMutation();

  return source === INCORPORATION_FORM_SOURCE.TEMPLATE
    ? templateResult
    : instanceResult;
};

export const useReorderFormTreeMutation = ({
  source,
}: UseFormTreeNodeMutationsArgs) => {
  const templateResult = useReorderFormTemplateTreeMutation();
  const instanceResult = useReorderFormInstanceTreeMutation();

  return source === INCORPORATION_FORM_SOURCE.TEMPLATE
    ? templateResult
    : instanceResult;
};
